var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#b3ddee;}.cls-1,.cls-3,.cls-7{stroke:#0090b9;}.cls-1,.cls-3,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-1,.cls-6{stroke-width:2px;}.cls-2{fill:#fff;stroke-linejoin:round;stroke-width:1.88px;}.cls-2,.cls-6{stroke:#42a9d2;stroke-linecap:round;}.cls-3{fill:#f9f9f9;}.cls-3,.cls-7{stroke-width:1.5px;}.cls-5{fill:#42a9d2;}.cls-6,.cls-7{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,100.85v2.36H48.39v-2.36a3.33,3.33,0,0,1,3.28-3.37h7.75v-9.4H77v9.4h7.75A3.32,3.32,0,0,1,88,100.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.24,87.58H25.18a7.14,7.14,0,0,1-7.08-7.19v-56a7.13,7.13,0,0,1,7.08-7.18h86.06a7.13,7.13,0,0,1,7.08,7.18v56A7.14,7.14,0,0,1,111.24,87.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.18,82a1.64,1.64,0,0,1-1.62-1.65v-56a1.64,1.64,0,0,1,1.62-1.65h86.06a1.64,1.64,0,0,1,1.62,1.65v56A1.64,1.64,0,0,1,111.24,82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.2,81.86a1.64,1.64,0,0,1-1.63-1.65v-56a1.64,1.64,0,0,1,1.63-1.65h86.06a1.64,1.64,0,0,1,1.62,1.65v56a1.64,1.64,0,0,1-1.62,1.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.23,
    y: 28.64,
    width: 39.87,
    height: 22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.23,
    y: 53.64,
    width: 39.87,
    height: 22
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.6,
    y: 28.64,
    width: 39.87,
    height: 22
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.6,
    y: 53.64,
    width: 39.87,
    height: 22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.61,45.7v2.84l-15.16,0,0-2v-.9a7,7,0,0,1,3-2.82l.07,0a22.54,22.54,0,0,1,2.6-1.09l.1-.48A4.68,4.68,0,0,1,35,39a1.47,1.47,0,0,1-.43-2.2s-.72-4.38,3.5-4.35,3.48,4.34,3.48,4.34a1.53,1.53,0,0,1-.37,2.26s-.47,2-1.27,2.21l.08.48a21.32,21.32,0,0,1,2.37,1l0,0C43.79,43.55,45.38,44.6,45.61,45.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.61,70.69v2.85l-15.16,0,0-2v-.89a7.07,7.07,0,0,1,3-2.83l.07,0a22.35,22.35,0,0,1,2.6-1.1l.1-.48A4.65,4.65,0,0,1,35,64a1.48,1.48,0,0,1-.43-2.21s-.72-4.37,3.5-4.35,3.48,4.35,3.48,4.35a1.53,1.53,0,0,1-.37,2.26s-.47,2-1.27,2.21l.08.47a20.39,20.39,0,0,1,2.37,1l0,0C43.79,68.54,45.38,69.59,45.61,70.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88,45.7v2.84l-15.16,0,0-2v-.9a7,7,0,0,1,3-2.82l.06,0a23.6,23.6,0,0,1,2.61-1.09l.1-.48A4.59,4.59,0,0,1,77.32,39a1.47,1.47,0,0,1-.43-2.2s-.73-4.38,3.5-4.35,3.47,4.34,3.47,4.34a1.52,1.52,0,0,1-.36,2.26s-.47,2-1.27,2.21l.08.48a22.28,22.28,0,0,1,2.37,1l0,0C86.16,43.55,87.75,44.6,88,45.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88,70.69v2.85l-15.16,0,0-2v-.89a7,7,0,0,1,3-2.83l.06,0a23.39,23.39,0,0,1,2.61-1.1l.1-.48A4.57,4.57,0,0,1,77.32,64a1.48,1.48,0,0,1-.43-2.21s-.73-4.37,3.5-4.35,3.47,4.35,3.47,4.35a1.52,1.52,0,0,1-.36,2.26s-.47,2-1.27,2.21l.08.47a21.27,21.27,0,0,1,2.37,1l0,0C86.16,68.54,87.75,69.59,88,70.69Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.23,
    y1: 37.56,
    x2: 61.6,
    y2: 37.56
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.23,
    y1: 43.06,
    x2: 61.6,
    y2: 43.06
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 91.6,
    y1: 36.89,
    x2: 103.97,
    y2: 36.89
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 91.6,
    y1: 42.39,
    x2: 103.97,
    y2: 42.39
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.92,
    y1: 62.58,
    x2: 62.29,
    y2: 62.58
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.92,
    y1: 68.07,
    x2: 62.29,
    y2: 68.07
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 91.6,
    y1: 63.26,
    x2: 103.97,
    y2: 63.26
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 91.6,
    y1: 68.76,
    x2: 103.97,
    y2: 68.76
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24.91,82a1.64,1.64,0,0,1-1.62-1.65v-56a1.64,1.64,0,0,1,1.62-1.65H111a1.64,1.64,0,0,1,1.62,1.65v56A1.64,1.64,0,0,1,111,82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail1);
export default __webpack_public_path__ + "static/media/mail1.25fe567874a0ab5b53f55d25dd0da412.svg";
export { ForwardRef as ReactComponent };